export const BuildingDebtTypes = {
  ADD_BUILDING_DEBT: "ADD_BUILDING_DEBT",
};
